/**
 * Utility for saving and fetching JWT and refresh tokens from the local storage.
 */
class TokenStorage {

  private static readonly JWT_TOKEN_KEY = "workbench_access_token";
  private static readonly REFRESH_TOKEN_KEY = "workbench_refresh_token";

  static getAccessToken() {
    return localStorage.getItem(TokenStorage.JWT_TOKEN_KEY);
  }

  static getRefreshToken() {
    return localStorage.getItem(TokenStorage.REFRESH_TOKEN_KEY);
  }

  static hasAccessToken() {
    return this.getAccessToken() !== null;
  }

  static hasRefreshToken() {
    return this.getRefreshToken() !== null;
  }

  static hasTokens() {
    return TokenStorage.hasAccessToken() && TokenStorage.hasRefreshToken();
  }

  static clear() {
    localStorage.removeItem(TokenStorage.JWT_TOKEN_KEY);
    localStorage.removeItem(TokenStorage.REFRESH_TOKEN_KEY);
  }

  static saveAccessToken(accessToken: string) {
    localStorage.setItem(TokenStorage.JWT_TOKEN_KEY, accessToken);
  }

  static saveRefreshToken(refreshToken: string) {
    localStorage.setItem(TokenStorage.REFRESH_TOKEN_KEY, refreshToken);
  }

}

export default TokenStorage;
